import { supabase } from "../supabaseClient";

async function getFos(cpId, from, to, search, drpDownSelectedVal, tabValue) {
  var query;
  // console.log(tabValue);
  // name.ilike.`%${search}%`,id.ilike.`%${search}%`
  if (search) {
    search = search.replace(/\s\s+/g, " ");
  }
  const filters = {
    "Name Ascending": {
      key: "name",
      isAscending: true,
    },
    "Name Descending": {
      key: "name",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };
  console.log([
    filters[drpDownSelectedVal].key,
    { ascending: filters[drpDownSelectedVal].isAscending },
  ]);
  console.log(tabValue);
  if (tabValue === "reassign") {
    query = await supabase
      .from("FOS")
      .select("*,KycDocuments!left(*)", { count: "exact" })
      .neq("cpId", cpId)
      .cs("previousCps", [`${cpId}`])
      .or(`name.ilike.%${search}%,fosDisplayId.ilike.%${search}%`);
  } else if (tabValue === "pending") {
    query = await supabase
      .from("FOS")
      .select("*,KycDocuments!left(*)", { count: "exact" })
      .eq("cpId", cpId)
      .or(`approvalStatus.eq.pending, approvalStatus.eq.resubmitted`)
      .or(`name.ilike.%${search}%,fosDisplayId.ilike.%${search}%`)
      .range(from, to)
      .order(filters[drpDownSelectedVal].key, {
        ascending: filters[drpDownSelectedVal].isAscending,
      });
  } else {
    query = await supabase
      .from("FOS")
      .select("*,KycDocuments!left(*)", { count: "exact" })
      .eq("cpId", cpId)
      .eq("approvalStatus", tabValue)
      .or(`name.ilike.%${search}%,fosDisplayId.ilike.%${search}%`)
      .range(from, to)
      .order(filters[drpDownSelectedVal].key, {
        ascending: filters[drpDownSelectedVal].isAscending,
      });
  }

  const { data, error, count } = query;
  console.log(from, to);

  if (data) return { data, count };
  else {
    console.log(error);
    throw error;
  }
}
async function getFosReassigned(cpId) {
  const { data, error, count } = await supabase
    .from("FOS")
    .select("*,KycDocuments!left(*)", { count: "exact" })
    .neq("cpId", cpId)
    .cs("previousCps", [`${cpId}`]);
  if (data) return { data, count };
  else throw error;
}

async function updateStatus(fosId, status, rejectionReason) {
  const { data, error } = await supabase
    .from("FOS")
    .update({
      approvalStatus: status,
      rejectionReason: rejectionReason,
      last_updated_at: Date.now(),
    })
    .eq("fosId", fosId);
  if (data) return data;
  else {
    console.log(error);
    throw error;
  }
}
async function getCpContactPersonId(cpId) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*")
    .eq("cpId", cpId);
  if (data) return data;
  else throw error;
}

async function insertFoSLogs(fosId, status, cpContactPersonId) {
  const { data, error } = await supabase
    .from("FosLogs")
    .insert([
      { fosId: fosId, fosStatus: status, cpContactPersonId: cpContactPersonId },
    ]);
  if (data) return data;
  else throw error;
}
async function getTotalLeadsCountOfFos(fosId, cpId, tabValue, loggedInCp) {
  let query;
  if (tabValue === "reassign") {
    query = await supabase
      // .from("FOS")
      // .select("*,KycDocuments!left(*), Leads!left(*)", { count: "exact" })
      // // .eq("cpId", loggedInCp)
      // .cs("previousCps", [`${cpId}`]);
      .from("Leads")
      .select("*", { count: "exact" })
      .eq("fosId", fosId)
      .eq("cpId", loggedInCp);
  } else {
    query = await supabase
      .from("Leads")
      .select("*", { count: "exact" })
      .eq("fosId", fosId)
      .eq("cpId", cpId);
  }
  const { data, error, count } = query;
  if (data) {
    console.log(data);
    return count;
  } else throw error;
}
async function getSiteVisitCountOfFos(fosId, cpId) {
  const { data, error, count } = await supabase
    .from("SiteVisits")
    .select("*", { count: "exact" })
    .eq("fosId", fosId)
    .eq("cpId", cpId);
  if (data) return count;
  else throw error;
}
async function getAllotmentCountOfFos(fosId, cpId) {
  // needs joins
  // const { data, error, count } = await supabase
  //   .from("AllotmentPayment")
  //   .select("*,Leads!left(leadId)", { count: "exact" })
  //   .eq("Leads.cpId", cpId)
  //   .eq("Leads.fosId", fosId);
  // if (data) return count;
  // else throw error;
  const { data,count, error } = await supabase.rpc('getallotmentcount', {cpid: cpId , fosid: fosId}, { count: 'exact' })
  if (data) return data;
  else throw error;
}
// async function getAgreementCountOfFos(fosId) {    // not considered
//   const { data, error, count } = await supabase.from('Agreements').select('*', { count: 'exact' }).eq('fosId', fosId);
//   if (data) return count;
//   else throw error;
// }

async function getPreviousCp(cpId){
  const { data, error, count } = await supabase
  .from("CpContactPerson")
  .select("*,cpId(*)")
  .eq("cpId", cpId)
  .single();
if (data) return data;
else throw error;
}
export {
  getFos,
  updateStatus,
  insertFoSLogs,
  getCpContactPersonId,
  getTotalLeadsCountOfFos,
  getSiteVisitCountOfFos,
  getAllotmentCountOfFos,
  getFosReassigned,
  getPreviousCp
};
